export const getters = {
  LabouritemsRows: state => state.labour_item,
  systemLabours: state => state.labours,
  EditLabourCharges: state => state.labour_items
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/labours/getters.js